import { createGlobalStyle } from 'styled-components';

import { GlobalStyles as PhoenixGlobalStyles } from '@formstack/phoenix/components/GlobalStyles';
import { GlobalTypographyStyles } from '@formstack/phoenix/components/Typography';
import '@formstack/phoenix/setup';

const CopilotGlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font-size: 1em;
  }

  *:not(._GLOBAL_RICH_TEXT_OUTPUT_ *, ._GLOBAL_CODE_EDITOR_OUTPUT_ *) {
    font-family: 'Poppins', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }
`;

const GlobalStyle = () => (
  <>
    <PhoenixGlobalStyles />
    <GlobalTypographyStyles />
    <CopilotGlobalStyle />
  </>
);

export { GlobalStyle };
